module.exports = __webpack_public_path__ + "img/icon-activate_extension.c8df8dd8.svg";